import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Route } from '@angular/router';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { STATION_CODE } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';

@Component({
    selector: 'app-station-details',
    templateUrl: './station-details.component.html',
    styleUrls: ['./station-details.component.scss'],
    standalone: false
})
export class StationDetailsComponent implements OnInit {
  @Output() onStationClick = new EventEmitter<Stop>();
  @Input() station: Stop;

  @Input() stopcodeColor?: string;

  stationCodeText: string;
  direction: Direction;

  stationName: string;

  constructor(private readonly languageService: LanguageService) {}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.stationCodeText = STATION_CODE[language.language];
      this.stationName = this.station.name[language.symbol] || this.station.name.he || this.station.name ||'';
    });
  }
}
